import React from 'react'
import {
  Center,
  Heading,
  Spacer,
} from '@chakra-ui/react'
import { ColorModeSwitch } from './ColorModeSwitch'

import Help from './Help'
import Stats from './Stats'


const Header = ({isFirstRun, onClosePopOver, stats}) => {
  return (
    <Center w={'100%'}>
        <Stats stats={stats}/>
        <Help isFirstRun={isFirstRun} onClosePopOver={onClosePopOver}/>
        <Heading size={'md'} fontWeight='semibold' color='cyan.400'>
          The Daily Trivia Party
        </Heading>
        <Spacer />
        <ColorModeSwitch />
      </Center>
  )
}

export default Header